import React from 'react';
import { Button, useMediaQueryContext } from '@fourthwall/components';
import * as S from './AddMembersOnlyAudio.styled';
export const AddMembersOnlyAudio = ({ onClick }) => {
    const media = useMediaQueryContext();
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Shape, { style: { width: '100%', aspectRatio: '1/1' } }),
            React.createElement(S.Info, null,
                React.createElement(S.Shape, { style: { height: 21, width: '90%' } }),
                React.createElement(S.Shape, { style: { height: 21, width: '80%' } }),
                React.createElement(S.Shape, { style: { height: 21, width: '90%' } }),
                React.createElement(S.Shape, { style: { height: 21, width: '70%' } }))),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: media.tablet ? 'Add members-only audio to Spotify' : 'Add members-only audio', appearance: "primary", onClick: onClick }))));
};
